@if (selectedChannel) {
  @if (loading) {
    <div>
      <h4>loading messages</h4>
      <app-spinner></app-spinner>
    </div>
  }
  @if (!error && !loading) {
    <section class="messaging">
      <div class="messaging-container" #divToScroll>
        <div class="messaging-messages">
          @for (msg of messages; track msg) {
            @if (isCurrentUser(msg.author)) {
              <app-agent-message
                [msg]="msg"
              ></app-agent-message>
            }
            @if (!isCurrentUser(msg.author)) {
              <app-customer-message
                [msg]="msg"
              ></app-customer-message>
            }
          }
          <br /><br />
        </div>
      </div>
      <div class="messaging-input-container">
        @if (typingMessage) {
          <span>{{ typingMessage }}</span>
        }
        <div class="messaging-input">
          <form class="messaging-input-form">
            <textarea
              (focus)="emitFocus($event)"
              (focusout)="emitFocusOut($event)"
              maxlength="8000"
              rows="5"
              class="form-input"
              placeholder="Type a message"
              (keydown)="sendTyping($event)"
              [(ngModel)]="twoWayMessage"
              [ngModelOptions]="{ standalone: true }"
            ></textarea>
            <button
              type="submit"
              class="form-send"
              (click)="sendMessage()"
              [disabled]="disableSend()"
              >
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  }
}
